import * as types from '../constants/Types'
import * as resource from '../constants/Resources'
import * as dataActions from '../actions/dataActions'
import * as rl from '../models/ReceiptLine'

export const createReceiptLines = lines => lines.map(line => ({
  ItemId: line.itemid,
  Price: (line.price.toFixed(2)) / 1,
  Quantity: line.quantity,
  Text: line.text,
  LineType: line.linetype,
  Configurations: line.configuration,
  Discounts: line.discount,
  ProductionPrinted: line.productionprinted,
  ProductionEdited: line.configurationedit,
  QuantityPaid: line.quantitypaid,
  CustomerId: line.customerid,
  TransactionLogId: line.transactionlogid,
  Weight: line.weight,
  BrandName: line.brandname,
  ClientTicket: line.clientticket,
  SimpleSeparator: line.simpleSeparator,
  KeyId: line.keyid,
  TicketBarcode: line.ticketbarcode,
  TicketStartDate: line.ticketStartDate,
  TicketEndDate: line.ticketEndDate,
  ProductionProcessed: line.productionprocessed,
  VatID: line.vatid,
  RegistrationDateTime: line.registrationDateTime
}));

// Receipt functions
export function saveReceipt() {
  return function (dispatch, getState) {
    const receiptLines = createReceiptLines(getState().receiptState.receipt.lines);
    const receipt = dispatch(createReceipt(receiptLines,
      getState().receiptState.receipt.objectitemid,
      getState().receiptState.receipt.receiptnumber,
      getState().receiptState.receipt.objectitemname,
      getState().receiptState.receipt.combinedobjectitems
    ));

    return receipt;
  }
}

export const openReceipt = receipt => receipt.Receipt.map((line, index) => ({
  id: index,
  itemid: line.ItemId,
  price: line.Price,
  openprice: line.Price / line.Quantity,
  quantity: line.Quantity,
  text: line.Text,
  linetype: line.LineType,
  configuration: line.Configurations,
  discount: line.Discounts,
  productionprinted: line.ProductionPrinted,
  editable: true,
  quantitypaid: line.QuantityPaid,
  customerid: line.CustomerId,
  transactionlogid: line.TransactionLogId,
  weight: line.Weight,
  brandname: line.BrandName,
  clientticket: line.ClientTicket,
  simpleSeparator: line.SimpleSeparator,
  keyid: line.KeyId,
  ticketbarcode: line.TicketBarcode,
  ticketStartDate: line.TicketStartDate,
  ticketEndDate: line.TicketEndDate,
  productionprocessed: line.ProductionProcessed,
  vatid: line.VatID,
  registrationDateTime: line.registrationDateTime
}));

export function consolidateLines(lines, transferReceipt = false) {
  return dispatch => {
    let result = [];
    lines.forEach(l => {
      const rlParam = rl.Get();
      rlParam.Text = l.text;
      rlParam.Price = l.quantity === 0 ? 0 : (l.price / l.quantity);
      rlParam.Quantity = l.quantity;
      rlParam.ItemId = l.itemid;
      rlParam.LineType = l.linetype;
      rlParam.Editable = l.editable;
      rlParam.ProductionPrinted = l.productionprinted;
      rlParam.SimpleSeparator = l.simpleSeparator;
      rlParam.KeyId = l.keyid;
      rlParam.ProductionProcessed = l.productionprocessed;
      rlParam.VatID = l.vatid;
      rlParam.RegistrationDateTime = l.registrationDateTime;

      const rlParamOptional = rl.GetOptional();
      rlParamOptional.Configuration = l.configuration;
      rlParamOptional.TicketBarcode = l.ticketbarcode;
      rlParamOptional.TicketStartDate = l.ticketStartDate;
      rlParamOptional.TicketEndDate = l.ticketStartDate;

      const newlines = dispatch(addReceiptLine(rlParam, rlParamOptional, result, transferReceipt));
      result = newlines.lines;
    });

    return result;
  }
}

export function createReceipt(lines, objectitemid, receiptnumber, objectitemname, combinedobjectitems) {
  return function (dispatch, getState) {
    const receipt = {
      PosId: getState().generalState.posId,
      SystemUserId: getState().loginState.loggedin.id,
      DeviceGuid: getState().generalState.uniqueid,
      Receipt: lines,
      ReceiptNumber: receiptnumber,
      IsRefund: getState().receiptState.receipt.isrefund,
      Devices: getState().generalState.devices,
      ObjectItemId: objectitemid,
      ObjectItemName: objectitemname,
      CombinedObjectItems: combinedobjectitems,
      CustomerId: getState().receiptState.receipt.customer.customerid,
      PriceListId: getState().receiptState.receipt.pricelistid,
      CardNumber: getState().receiptState.receipt.cardname,
      PaymentDevice: {
        PaymentId: getState().receiptState.receipt.paymentdevice.paymentid,
        OldBalance: getState().receiptState.receipt.paymentdevice.oldbalance,
        NewBalance: getState().receiptState.receipt.paymentdevice.newbalance
      },
      ShouldInvoice: getState().receiptState.receipt.shouldinvoice,
      InvoiceReference: getState().receiptState.receipt.invoiceReference,
      ReservationId: getState().receiptState.receipt.reservationId,
      PagerNumber: getState().receiptState.receipt.pagerNumber,
    }

    return receipt;
  }
}

// ReceiptLine functions
export function addReceiptLine(rlParam, rlParamOptional, receiptLines, transferReceipt) {
  return function (dispatch, getState) {
    if (receiptLines === undefined) {
      receiptLines = getState().receiptState.receipt.lines;
    }

    var result = {
      lines: [],
      newLine: false
    };

    const newline = {};
    newline.editable = rlParam.Editable;
    newline.itemid = rlParam.ItemId;
    newline.linetype = rlParam.LineType;
    newline.price = rlParam.Price * rlParam.Quantity;
    newline.openprice = rlParam.Price;
    newline.quantity = rlParam.Quantity;
    newline.text = rlParam.Text;
    newline.selected = false;
    newline.productionprinted = rlParam.ProductionPrinted;
    newline.configurationedit = rlParamOptional.ConfigurationEdit;
    newline.quantitypaid = 0;
    newline.vatid = 0;
    newline.discount = [];
    newline.customerid = rlParamOptional.CustomerId;
    newline.transactionlogid = rlParamOptional.TransactionLogId;
    newline.weight = rlParamOptional.Weight;
    newline.brandname = rlParamOptional.BrandName;
    newline.clientticket = rlParamOptional.ClientTicket;
    newline.simpleSeparator = rlParamOptional.SimpleSeparator;
    newline.keyid = rlParam.KeyId;
    newline.processed = rlParam.Processed;
    newline.ticketbarcode = rlParamOptional.TicketBarcode;
    newline.ticketStartDate = rlParamOptional.TicketStartDate || rlParam.TicketStartDate;
    newline.ticketEndDate = rlParamOptional.TicketEndDate || rlParam.TicketEndDate;
    newline.productionprocessed = rlParam.ProductionProcessed;
    newline.registrationDateTime = new Date();
    newline.vatid = rlParam.VatID;

    const article = dispatch(dataActions.getArticle(rlParam.ItemId));

    const lineconfiguration = [];
    if (rlParamOptional.Configuration.length > 0) {
      let configurationPrice = 0;
      rlParamOptional.Configuration.map(configurationStep => {
        const lineStep = configurationStep;
        const configurationStepValue = dispatch(dataActions.getArticleConfigurationStepValue(configurationStep.ConfigurationStepId, configurationStep.ConfigurationStepValueId));

        if (configurationStepValue !== null) {
          lineStep.Price = configurationStepValue.SalesPrice;
          lineStep.ArticleId = configurationStepValue.ArticleId;
          configurationPrice += configurationStepValue.SalesPrice;

          //if configuration is an article
          if (lineStep.ArticleId > 0 && lineStep.UseArticlePrice) {
            let configArticle = dispatch(dataActions.getArticle(lineStep.ArticleId));
            configurationPrice += configArticle.SalesPrice;
          }
        }
        lineconfiguration.push(lineStep);
        return '';
      });

      if (!transferReceipt) {
        newline.price += (configurationPrice * rlParam.Quantity);
      }
    }

    newline.configuration = lineconfiguration;

    const lines = [];
    let id = 1;

    let groupedlines = [];
    receiptLines.map(l => {
      const line = l;
      if (line.linetype === types.SUBTOTAL_LINE) {
        lines.push.apply(lines, groupedlines);
        lines.push(line);
        groupedlines = [];
      } else if (line.linetype === types.RECEIPT_INFO_LINE) {
        line.price = 0;
        lines.push.apply(lines, groupedlines);
        lines.push(line);
        groupedlines = [];
      } else {
        groupedlines.push(line);
      }

      id = line.id;
      return '';
    });
    id++;

    let newArticlePrice = 0;
    if (newline.quantity > 0) {
      newArticlePrice = Math.abs(newline.price / newline.quantity).toFixed(2);
    }

    let found = false;
    groupedlines.map(line => {
      const editableline = line;
      let orgArticlePrice = 0;
      if (line.quantity > 0) {
        orgArticlePrice = Math.abs(line.price / line.quantity).toFixed(2);
      }

      //Articles with article configurations are not calculated before this statement
      if (!found
        && line.itemid === newline.itemid
        && line.linetype === newline.linetype
        && compareConfiguration(line.configuration, newline.configuration)
        && line.linetype === types.ARTICLE_LINE
        && !article.OpenPrice
        && !article.UseScale) {
        //only combine lines when not in BB and if lines are identical
        if (!(getState().generalState.licenses.blackbox && getState().generalState.hasBlackbox)) {
          if (orgArticlePrice === newArticlePrice && editableline.text === newline.text &&
            ((line.quantity > 0 && newline.quantity > 0) || (line.quantity < 0 && newline.quantity < 0))) {
            editableline.quantity = parseFloat((editableline.quantity + newline.quantity).toPrecision(15));
            editableline.price = parseFloat((editableline.price + newline.price).toPrecision(15));
            editableline.productionprinted += newline.productionprinted;
            editableline.configurationedit = rlParamOptional.ConfigurationEdit;
            editableline.simpleSeparator = rlParamOptional.simpleSeparator;
            found = true;
          }
        }
      }
      editableline.selected = false;

      if (editableline.quantity !== 0) {
        lines.push(editableline);
      }
      return 0;
    });
    if (!found) {
      newline.id = id;
      if (newline.linetype === types.ARTICLE_LINE) {
        newline.blockdiscount = article.BlockDiscount;

        //Set receiptline unprocessed
        if (getState().receiptState.receipt.objectitemid > 0) {
          newline.productionprocessed = false;
        }
      }

      lines.push(newline);
      id++;

      result.newLine = true;
    }
    result.lines = lines;

    return result;
  }
}

export function removeReceiptLine(getState, lineid) {
  const result = [];
  const originalLines = getState().receiptState.receipt.lines;
  if (originalLines.find(line => line.id === lineid && line.productionprinted === 0)
    && (!(getState().generalState.licenses.blackbox && getState().generalState.hasBlackbox)
      || originalLines.find(line => line.id === lineid && !line.blackBox_disable_edit))) {
    getState().receiptState.receipt.lines.map(line => {
      if (line.id !== lineid) {
        result.push(line);
      }
      return 0;
    });
  } else {
    let newlines = []

    let selectedLine = getSelectedLine(getState);

    if (selectedLine === null)
      selectedLine = getLastLine(getState);;

    let price = 0;
    if (selectedLine.quantity !== 0) {
      price = selectedLine.price / selectedLine.quantity;
    }

    let removedLineFound = false;
    getState().receiptState.receipt.lines.map(line => {
      const customLine = line;

      if (line.itemid === selectedLine.itemid
        && line.editable
        && line.linetype === selectedLine.linetype
        && compareConfiguration(line.configuration, selectedLine.configuration)
        && selectedLine.linetype === types.ARTICLE_LINE
        && line.productionprinted === 0
        && (!line.blackBox_disable_edit || ((selectedLine.quantity > 0 && line.quantity < 0)
          || (selectedLine.quantity < 0 && line.quantity > 0)))) {
        removedLineFound = true;
        customLine.quantity = selectedLine.quantity * -1;
        customLine.price = price * (selectedLine.quantity * -1);
      }
      newlines.push(customLine);
      return '';
    });

    if (!removedLineFound || (getState().generalState.licenses.blackbox &&
        getState().generalState.hasBlackbox &&
        CompareLines(getState().receiptState.receipt.lines, selectedLine))) {
      getState().receiptState.receipt.lines.map(line => {
        if (line.id === lineid) {
          const newline = {};
          newline.editable = false;
          newline.itemid = line.itemid;
          newline.linetype = line.linetype;
          newline.price = price * (line.quantity * -1);
          newline.openprice = price;
          newline.quantity = (line.quantity * -1);
          newline.text = line.text;
          newline.configuration = line.configuration;
          newline.selected = false;
          newline.productionprinted = 0;
          newline.quantitypaid = 0;
          newline.vatid = 0;
          newline.discount = [];
          line.discount.map(discount => {
            newline.discount.push({
              Description: discount.Description,
              Value: discount.Value,
              Price: discount.Price * -1,
              Type: discount.Type
            });
            return '';
          })
          newlines.push(newline);
          selectedLine.editable = false;
        }
        return 0;
      });
    }

    let id = 1;
    newlines.map(line => {
      const newline = line;
      if (line.id === lineid) {
        newline.selected = false;
      }
      line.id = id;
      result.push(newline);
      id++;
      return 0;
    });
  }

  return result;

}

//Compare lines to determine how many of the same lines we can still remove (only for BB)
function CompareLines(lines, selectedLine) {
  let addLines = 0;
  let minusLines = 0;

  lines.map(line => {

    //check if article is item is identical, then check if they have the same configuration
    if (line.itemid === selectedLine.itemid)
      if (line.configuration === selectedLine.configuration)
        line.quantity > 0 ? addLines++ : minusLines++;

    return '';
  });

  if (minusLines < addLines)
    return true;
  else
    return false;
}

function editQuantity(getState, lineId, add) {
  const result = [];
  getState().receiptState.receipt.lines.map(line => {
    const current = line;
    if (lineId === line.id) {
      const price = line.price / line.quantity;
      if (add) {
        current.quantity++;
      } else {
        current.quantity--;
      }

      current.quantity = parseFloat(current.quantity.toFixed(2));
      current.price = price * current.quantity;
    }

    if (current.quantity > 0
      || current.quantity < 0) {
      result.push(current);
    }
    return 0;
  });

  return result;
}

export function addQuantity(getState, lineId) {
  return editQuantity(getState, lineId, true);
}

export function removeQuantity(getState, lineId) {
  return editQuantity(getState, lineId, false);
}

export function setSelectedLine(getState, lineId) {
  const result = [];
  getState().receiptState.receipt.lines.map(line => {
    const current = line;
    if (lineId === line.id) {
      current.selected = !line.selected;
    } else {
      current.selected = false;
    }

    result.push(current);

    return 0;
  });

  return result;
}
export function getSelectedLine(getState) {
  let result = null;
  getState().receiptState.receipt.lines.map(line => {
    if (line.selected) {
      result = line;
    };
    return '';
  });
  return result;
}

export function getLastLine(getState) {

  let lines = getState().receiptState.receipt.lines;
  let result = null;

  if (lines.length === 0)
    return null;

  for (var i = lines.length - 1; i >= 0; i--) {
    if (lines[i].editable) {
      result = lines[i];
      break;
    }
  }

  return result;

}

export function updateReceiptlineWithConfiguration(getState, lineid, article, configuration) {
  const configurationSteps = getState().generalState.configurationsteps;
  let configurationPrice = 0;
  configuration.map(conf => {
    configurationSteps.map(confII => {
      if (conf.ConfigurationStepId === confII.ArticleConfigurationStepId) {
        confII.ArticleConfigurationStepValues.map(val => {
          if (val.ArticleConfigurationStepValueId === conf.ConfigurationStepValueId) {
            configurationPrice += val.SalesPrice;
          }
          return '';
        })
      }
      return '';
    })
    return '';
  });

  const result = [];
  getState().receiptState.receipt.lines.map(line => {
    const current = line;
    if (lineid === line.id) {
      current.configuration = configuration;
      current.price = (article.SalesPrice * current.quantity) + (configurationPrice * current.quantity);
    }

    result.push(current);

    return 0;
  });

  return result;
}

export function compareConfiguration(configurationA, configurationB) {
  if (!configurationA) {
    return false;
  }

  if (!configurationB) {
    return false;
  }

  // compare lengths - can save a lot of time 
  if (configurationA.length !== configurationB.length) {
    return false;
  }

  for (var i = 0, l = configurationA.length; i < l; i++) {
    if (configurationA[i].ConfigurationStepId !== configurationB[i].ConfigurationStepId) {
      return false;
    }
    if (configurationA[i].ConfigurationStepValueId !== configurationB[i].ConfigurationStepValueId) {
      return false;
    }
    if (configurationA[i].ConfigurationStepValueDescription !== configurationB[i].ConfigurationStepValueDescription) {
      return false;
    }
  }
  return true;
}

export function AddSubtotal(dispatch, getState) {
  const result = [];
  let subtotalAmount = 0;
  let id = 0;
  let lines = 0;
  getState().receiptState.receipt.lines.map(line => {
    const editableline = line;

    var ignoreLine = false;
    if (editableline.linetype === types.SUBTOTAL_LINE) {
      if (!editableline.simpleSeparator) {
        subtotalAmount = 0;
        lines = 0;
      }
      else {
        ignoreLine = true;
      }
    } else {
      let discountAmount = 0;
      line.discount.map(d => {
        discountAmount += d.Price;
        return '';
      })

      if (!ignoreLine) {
        subtotalAmount += ((line.price + discountAmount).toFixed(2)) / 1;
        lines++;
      }
    }

    result.push(editableline);
    id = editableline.id;
    return '';
  });

  if (lines > 0) {
    id++;
    const subtotalLine = {};
    subtotalLine.editable = true;
    subtotalLine.itemid = 1;
    subtotalLine.linetype = types.SUBTOTAL_LINE;
    subtotalLine.price = subtotalAmount
    subtotalLine.quantity = 1;
    subtotalLine.text = dispatch(dataActions.getTranslation(resource.SUB_TOTAL));
    subtotalLine.selected = false;
    subtotalLine.id = id;
    subtotalLine.discount = [];

    result.push(subtotalLine);
  }

  return result;
}

export function AddDiscountAmount(dispatch, getState, discountParam, lineForDiscount) {
  const result = [];
  let amount = discountParam.amount;
  let receiptDiscount = false;
  let id = 0;
  let lineDescription = dispatch(dataActions.getTranslation(resource.DISCOUNT));

  getState().receiptState.receipt.lines.map(line => {
    if (line.id === lineForDiscount.id) {
      if (line.linetype === types.SUBTOTAL_LINE) {
        receiptDiscount = true;
      } else {
        let currentDiscount = 0;
        line.discount.map(d => {
          currentDiscount += (d.Price.toFixed(2)) / 1;
          return '';
        });

        let restAmount = line.price + currentDiscount;
        if (restAmount < amount) {
          amount = restAmount;
        }

        if (amount < 0) {
          lineDescription = dispatch(dataActions.getTranslation(resource.SURCHAGE));;
        }
        var discountDescription = discountParam.discountDescription;
        if (discountDescription.length === 0) {
          discountDescription = lineDescription;
        }

        line.discount.push({
          Description: `${discountDescription} ${parseFloat(amount).toFixed(2).replace('.', ',')}`,
          Value: amount,
          Price: ((amount * -1).toFixed(2) / 1),
          Type: types.DISCOUNT_AMOUNT
        });
      }
      line.selected = false;
    }

    id = line.id;

    result.push(line);
    return '';
  });

  if (receiptDiscount) {
    id++;

    if (amount < 0) {
      lineDescription = dispatch(dataActions.getTranslation(resource.SURCHAGE));;
    }
    var discountDescription = discountParam.discountDescription;
    if (discountDescription.length === 0) {
      discountDescription = lineDescription;
    }

    const discountLine = {};
    discountLine.editable = true;
    discountLine.itemid = types.DISCOUNT_AMOUNT;
    discountLine.linetype = types.DISCOUNT_LINE;
    discountLine.price = ((parseFloat(amount).toFixed(2)) / 1) * -1;
    discountLine.quantity = parseFloat(amount);
    discountLine.text = `${discountDescription} ${parseFloat(amount).toFixed(2).replace('.', ',')}`;
    discountLine.selected = false;
    discountLine.id = id;
    discountLine.discount = [];

    result.push(discountLine);
  }

  return result;
}
export function AddDiscountPercentage(dispatch, getState, discountParam, lineForDiscount) {
  const result = [];
  let percentage = discountParam.percentage;
  const discountPercentage = parseInt(percentage, 10);
  let receiptDiscount = false;
  let id = 0;
  let lineDescription = dispatch(dataActions.getTranslation(resource.DISCOUNT));

  getState().receiptState.receipt.lines.map(line => {
    if (line.id === lineForDiscount.id) {
      if (line.linetype === types.SUBTOTAL_LINE) {
        receiptDiscount = true;
      } else {
        let currentDiscount = 0;
        line.discount.map(d => {
          currentDiscount += (d.Price.toFixed(2)) / 1;
          return '';
        });

        const totalAmount = line.price + currentDiscount;
        const amount = (totalAmount / 100.0) * discountPercentage;

        if (discountPercentage < 0) {
          lineDescription = dispatch(dataActions.getTranslation(resource.SURCHAGE));;
        }
        var discountDescription = discountParam.discountDescription;
        if (discountDescription.length === 0) {
          discountDescription = `${lineDescription} ${discountPercentage}%`;
        }
        line.discount.push({
          Description: discountDescription,
          Value: discountPercentage,
          Price: ((amount.toFixed(2)) / 1) * -1,
          Type: types.DISCOUNT_PERCENTAGE
        });
      }
      line.selected = false;
    }

    id = line.id;

    result.push(line);
    return '';
  });

  if (receiptDiscount) {
    id++;

    if (discountPercentage < 0) {
      lineDescription = dispatch(dataActions.getTranslation(resource.SURCHAGE));;
    }
    var discountDescription = discountParam.discountDescription;
    if (discountDescription.length === 0) {
      discountDescription = `${lineDescription} ${discountPercentage}%`;
    }

    const discountLine = {};
    discountLine.editable = true;
    discountLine.itemid = types.DISCOUNT_PERCENTAGE;
    discountLine.linetype = types.DISCOUNT_LINE;
    discountLine.price = 0;//parseFloat(amount) * -1;
    discountLine.quantity = discountPercentage;
    discountLine.text = discountDescription;
    discountLine.selected = false;
    discountLine.id = id;
    discountLine.discount = [];

    result.push(discountLine);
  }

  return result;
}
export function CalculateDiscount(lines) {
  const result = [];

  const discountLines = [];

  let receiptAmount = 0;
  let id = 1;
  lines.map(line => {
    const newLine = line;
    let linePrice = (line.price.toFixed(2)) / 1;
    if (!line.blockdiscount) {
      const discounts = [];
      line.discount.map(d => {
        const newDiscount = d;
        if (d.Type === types.DISCOUNT_PERCENTAGE || d.Type === types.CUSTOMER_GROUP_DISCOUNT) {
          const newPrice = (linePrice / 100.0) * d.Value;
          newDiscount.Price = (((newPrice.toFixed(2)) / 1) * -1);
        }
        linePrice += newDiscount.Price;
        discounts.push(newDiscount);
        return '';
      });
      newLine.discount = discounts;

      if (line.linetype === types.DISCOUNT_LINE) {
        discountLines.push(line);
      } else {
        newLine.id = id;
        result.push(newLine);
        id++;
      }
    } else {
      newLine.id = id;
      result.push(newLine);
      id++;
    }
    if (line.linetype === types.ARTICLE_LINE) {
      receiptAmount += linePrice;
    }
    return '';
  });

  discountLines.map(line => {
    const newLine = line;

    if (line.itemid === types.DISCOUNT_PERCENTAGE) {
      const newPrice = (receiptAmount / 100.0) * line.quantity;
      newLine.price = (((newPrice.toFixed(2)) / 1) * -1);
    }
    receiptAmount += newLine.price;

    newLine.id = id;
    result.push(newLine);
    id++;
    return '';
  })

  return result;
}

export function CalculatePriceList(lines) {
  return function (dispatch, getState) {
    const priceListId = getState().receiptState.receipt.pricelistid;
    const discountMenuArticleIDList = getState().generalState.discountMenuArticleIDList;
    const result = [];
    lines.forEach(l => {
      const line = l;
      if (line.linetype === types.ARTICLE_LINE && !discountMenuArticleIDList.includes(line.itemid)) {
        const article = dispatch(dataActions.getArticle(line.itemid));

        if (article !== null) {
          let price = article.SalesPrice * line.quantity;
          //Only use line.openprice if there isnt already a SalesPrice - will result in larger price numbers otherwise
          if (article.OpenPrice || article.UseScale) {
            price = line.openprice * line.quantity;
          }

          for (let i = 0; i < article.PriceLists.length; i++) {
            let priceList = article.PriceLists[i];
            if (priceList.PriceListId === priceListId && !priceList.DefaultPrice) {
              price = priceList.SalesPrice * line.quantity;
            }
          }

          //Loop through all configurations of current line
          for (let i = 0; i < line.configuration.length; i++) {
            const config = line.configuration[i];

            if (config !== null) {
              const configArticle = dispatch(dataActions.getArticle(config.ArticleId));
              if (configArticle !== null) {
                let configArticlePrice = configArticle.SalesPrice * line.quantity;
                for (let i = 0; i < configArticle.PriceLists.length; i++) {
                  let priceList = configArticle.PriceLists[i];
                  if (priceList.PriceListId === priceListId && !priceList.DefaultPrice) {
                    configArticlePrice = priceList.SalesPrice * line.quantity;
                  }
                }
                price += configArticlePrice;
              } else {
                price += config.Price * line.quantity;
              }
            }
          }
          line.price = price;
        }
      }

      result.push(line);
    });

    return result;
  }
}

export function CalculateSubtotal(lines) {
  const result = [];
  let subTotal = 0;
  lines.map(l => {
    const line = l;
    if (line.linetype !== types.SUBTOTAL_LINE) {
      subTotal += line.price;
      let discountAmount = 0;
      line.discount.map(d => {
        discountAmount += d.Price;
        return '';
      });
      subTotal += discountAmount;
    } else {
      if (!line.simpleSeparator) {
        line.price = subTotal;
        subTotal = 0;
      }
    }

    result.push(line);
    return '';
  });

  return result;
}

export function setProductionProcessed(getState, articleIds) {
  const result = [];

  getState().receiptState.receipt.lines.forEach(line => {
    const current = line;
    if (line.linetype === 100 && articleIds.includes(line.itemid)) {
      current.productionprocessed = true
    }

    result.push(current);
  });

  return result;
}

export function ApplyCustomerGroupDiscount(lines) {
  return function (dispatch, getState) {
    const customer = getState().receiptState.receipt.customer;
    const result = [];
    
    let id = 1;

    lines.forEach(line => {
      const newLine = { ...line };
      
      if (newLine.discount && newLine.discount.length > 0) {
        newLine.discount = newLine.discount.filter(d => d.Type !== types.CUSTOMER_GROUP_DISCOUNT);
      }

      // Apply new customer group discount if customer has a group with discount percentage
      if (customer && customer.customerid && customer.customerGroupId && customer.discountPercentage > 0) {
        if (newLine.linetype === types.ARTICLE_LINE && !newLine.blockdiscount) {
          const discountPercentage = customer.discountPercentage;
          const lineDescription = dispatch(dataActions.getTranslation(resource.DISCOUNT));
          const discountDescription = `${lineDescription} ${discountPercentage}% (${customer.customerGroup})`;

          newLine.discount = newLine.discount || [];
        
          newLine.discount.push({
            Description: discountDescription,
            Value: discountPercentage,
            Price: 0, // Will be calculated in CalculateDiscount
            Type: types.CUSTOMER_GROUP_DISCOUNT
          });
        }
      }
      
      newLine.id = id;
      result.push(newLine);
      id++;
    });

    return result;
  }
}



// WEBPACK FOOTER //
// src/functions/ReceiptFunctions.js